import { inspectionActions } from '@redux/slices/inspection';
import { tasksListsActions } from '@redux/slices/tasks';
import { getAppDispatch } from '@utilities/dispatch.util';

const workOrderUsers = ({ data = [] }) => {
  // const data = currentAPIResponseData?.value?.data || [];
  const workOrderUsers = data || [];
  const workOrderUsersMap = data.reduce((acc, curr) => {
    acc[curr.id] = curr;
    return acc;
  }, {});

  return {
    workOrderUsers,
    workOrderUsersMap
  };
};

const workOrderUserGroups = ({ data = [] }) => {
  const workOrderUsersGroups = data || [];
  const workOrderUsersGroupsMap = data.reduce((acc, curr) => {
    acc[curr.id] = curr;
    return acc;
  }, {});

  return {
    workOrderUsersGroups,
    workOrderUsersGroupsMap
  };
};

const workOrderAdministrators = ({ data }) => {
  const workOrderAdministrators = data || [];

  const workOrderAdministratorsMap =
    workOrderAdministrators?.reduce((acc, curr) => {
      acc[curr.id] = curr?.firstName + ' ' + curr.lastName;
      return acc;
    }, {}) || [];

  return {
    workOrderAdministrators,
    workOrderAdministratorsMap
  };
};

const workOrderAdministratorGroups = ({ data }) => {
  const workOrderAdministratorGroups = data || [];

  const workOrderAdministratorGroupsMap =
    workOrderAdministratorGroups?.reduce((acc, curr) => {
      acc[curr.id] = curr?.name || '';
      return acc;
    }, {}) || [];

  return {
    workOrderAdministratorGroups,
    workOrderAdministratorGroupsMap
  };
};

const inspectionInspectorUserGroups = ({ data }) => {
  const inspectionInspectorUserGroups = data || [];

  const inspectionInspectorUserGroupsMap = inspectionInspectorUserGroups?.reduce((acc, curr) => {
    acc[curr.id] = curr;
    return acc;
  }, {});

  return {
    inspectionInspectorUserGroups,
    inspectionInspectorUserGroupsMap
  };
};

const inspectionInspectorUsers = ({ data }) => {
  const inspectionInspectorUsers = data || [];
  const inspectionInspectorUsersMap = inspectionInspectorUsers?.reduce((acc, curr) => {
    acc[curr.id] = curr;
    return acc;
  }, {});

  return {
    inspectionInspectorUsers,
    inspectionInspectorUsersMap
  };
};

const assetLastInspectionDateMap = ({ data }) => {
  const inspectionLastDate = data?.items || [];
  let site = {},
    equipment = {},
    pipeline = {},
    siteLastInspectionDateWithIds = {},
    equipmentLastInspectionDateWithIds = {},
    pipelineInspectionDateWithIds = {};

  for (let item of inspectionLastDate) {
    if (item?.assetType === 'S' && item?.inspectionDate) {
      if (!site[item.assetId])
        site = {
          ...site,
          [item.assetId]: [
            {
              assetId: item.assetId,
              inspectionDate: item.inspectionDate
            }
          ]
        };
      else
        site = {
          ...site,
          [item.assetId]: [
            ...site[item.assetId],
            { assetId: item.assetId, inspectionDate: item.inspectionDate }
          ]
        };
    } else if (item?.assetId === 'E' && item?.inspectionDate) {
      if (!equipment[item.assetId])
        equipment = {
          ...equipment,
          [item.assetId]: [
            {
              assetId: item.assetId,
              inspectionDate: item.inspectionDate
            }
          ]
        };
      else
        equipment = {
          ...equipment,
          [item.assetId]: [
            ...equipment[item.assetId],
            { assetId: item.assetId, inspectionDate: item.inspectionDate }
          ]
        };
    } else if (item?.assetId === 'P' && item?.inspectionDate) {
      if (item.assetType === 'S' && item?.inspectionDate) {
        if (!pipeline[item.assetId])
          pipeline = {
            ...pipeline,
            [item.assetId]: [
              {
                assetId: item.assetId,
                inspectionDate: item.inspectionDate
              }
            ]
          };
        else
          pipeline = {
            ...pipeline,
            [item.assetId]: [
              ...pipeline[item.assetId],
              { assetId: item.assetId, inspectionDate: item.inspectionDate }
            ]
          };
      }
    }
  }

  for (let key in site)
    siteLastInspectionDateWithIds = {
      ...siteLastInspectionDateWithIds,
      [key]:
        (site[key]?.sort((a, b) => new Date(b?.inspectionDate) - new Date(a?.inspectionDate)) ||
          [])[0] || null
    };

  for (let key in equipment)
    equipmentLastInspectionDateWithIds = {
      ...equipmentLastInspectionDateWithIds,
      [key]:
        (equipment[key]?.sort(
          (a, b) => new Date(b?.inspectionDate) - new Date(a?.inspectionDate)
        ) || [])[0] || null
    };

  for (let key in pipeline)
    pipelineInspectionDateWithIds = {
      ...pipelineInspectionDateWithIds,
      [key]:
        (pipeline[key]?.sort((a, b) => new Date(b?.inspectionDate) - new Date(a?.inspectionDate)) ||
          [])[0] || null
    };

  return {
    siteLastInspectionDateWithIds,
    equipmentLastInspectionDateWithIds,
    pipelineInspectionDateWithIds
  };
};

const pass_fail_list = ({ data }) => {
  return (data || [])?.map((x) => {
    return {
      label: x?.value || '',
      value: x?.key || '',
      lookup: x?.lookup || ''
    };
  });
};

const pass_fail_listDispatcher = ({ data }) => {
  const dispatch = getAppDispatch();

  dispatch?.(inspectionActions?.setInspectionPassFailList(data));
};

const pass_deficiency_failDispatcher = ({ data }) => {
  const dispatch = getAppDispatch();

  dispatch?.(inspectionActions?.setInspectionPassFailDeficiencyList(data));
};

const pass_deficiency_fail = ({ data }) => {
  return (data || [])?.map((x) => {
    return {
      label: x?.value || '',
      value: x?.key || '',
      lookup: x?.lookup || ''
    };
  });
};

const workOrderUsersDispatcher = ({ data }) => {
  const dispatch = getAppDispatch();

  dispatch?.(tasksListsActions.setWorkOrdeUsersrList(data));
};

const workOrderUserGroupsDispatcher = ({ data }) => {
  const dispatch = getAppDispatch();
  dispatch?.(tasksListsActions.setWorkOrdeUsersrGroupsList(data));
};

const workOrderAdministratorsDispatcher = ({ data }) => {
  const dispatch = getAppDispatch();
  dispatch?.(tasksListsActions.setWorkOrderAdministrators(data?.workOrderAdministrators));
  dispatch?.(tasksListsActions.setWorkOrderAdministratorsMap(data?.workOrderAdministratorsMap));
};

const workOrderAdministratorGroupsDispatcher = ({ data }) => {
  const dispatch = getAppDispatch();
  dispatch?.(tasksListsActions.setWorkOrderAdministratorGroups(data?.workOrderAdministratorGroups));
  dispatch?.(
    tasksListsActions.setWorkOrderAdministratorGroupsMap(data?.workOrderAdministratorGroupsMap)
  );
};

const inspectionInspectorUserGroupsDispatcher = ({ data }) => {
  const dispatch = getAppDispatch();
  dispatch?.(
    inspectionActions.setInspectionInspectorUserGroups({
      inspectionInspectorUserGroups: data?.inspectionInspectorUserGroups,
      inspectionInspectorUserGroupsMap: data?.inspectionInspectorUserGroupsMap
    })
  );
};

const inspectionInspectorUsersDispatcher = ({ data }) => {
  const dispatch = getAppDispatch();
  dispatch?.(
    inspectionActions.setInspectionInspectorUsers({
      inspectionInspectorUsers: data?.inspectionInspectorUsers,
      inspectionInspectorUsersMap: data?.inspectionInspectorUsersMap
    })
  );
};

const assetLastInspectionDateMapDispatcher = ({ data }) => {
  const dispatch = getAppDispatch();
  dispatch?.(inspectionActions.setInspectionLastDate(data));
};
export {
  workOrderUsers,
  workOrderUserGroups,
  workOrderAdministrators,
  workOrderAdministratorGroups,
  inspectionInspectorUserGroups,
  inspectionInspectorUsers,
  assetLastInspectionDateMap,
  pass_fail_list,
  pass_deficiency_fail,
  workOrderUsersDispatcher,
  workOrderUserGroupsDispatcher,
  workOrderAdministratorsDispatcher,
  workOrderAdministratorGroupsDispatcher,
  inspectionInspectorUserGroupsDispatcher,
  inspectionInspectorUsersDispatcher,
  assetLastInspectionDateMapDispatcher,
  pass_deficiency_failDispatcher,
  pass_fail_listDispatcher
};
